<div class="investor-section">
  <!-- topic -->
  <div class="box-container">
    <div class="u-text-center">
      <h2
        class="new-headtext _heading u-mw-unset  font-size-big"
        [innerHTML]="'WORK_WITH_US.INVESTOR_SECTION.HEADING' | translate"
      ></h2>
    </div>

    <!-- more detail -->
    <div class="investor-section__readmore u-text-center">
      <a
        href="{{
          translate.currentLang === 'th' ? 'https://flowaccount.com/about-us' : 'https://flowaccount.com/en/about-us'
        }}"
        target="_blank"
        rel="noopener"
        class="link-app-line read-more"
        aria-label="read-more"
      >
        <span>{{ 'WORK_WITH_US.INVESTOR_SECTION.READ_MORE' | translate }}</span
        ><i class="fas fa-angle-right right"></i>
      </a>
    </div>

    <div class="investor-section__box">
      <div class="investor-section__logo-container u-box-center">
        <ng-container *ngFor="let item of logoList">
          <div class="investor-section__logo">
            <picture class="u-box-center">
              <source srcset="{{ item.imageWebP }}" type="image/webp" />
              <source srcset="{{ item.image }}" type="image/{{ item.imageType }}" />
              <img
                class="investor-section__logo--{{ item.imageClassName }}"
                src="{{ item.image }}"
                alt="{{ item.imageType }}"
                loading="lazy"
              />
            </picture>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
